import { /*LOCALE_ID, */ APP_ID, NgModule } from '@angular/core';
// import { registerLocaleData } from '@angular/common';
// import localeIt from '@angular/common/locales/it';
//
// registerLocaleData(localeIt, 'it');

// modules (angular)
import { BrowserModule, Title } from '@angular/platform-browser';

// modules (third-party)
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// modules
import { AppRoutingModule } from './app-routing.module';

// components

// pages
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    HttpClientModule
} from '@angular/common/http';
import { CookieInterceptor } from './_guards/cookie.interceptor';
import { NotFoundInterceptor } from './_guards/not-found.interceptor';
import { CountryInterceptor } from './_guards/country.interceptor';
import { MaintenanceInterceptor } from './_guards/maintenance.interceptor';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BlockProductCarouselNewModule } from './_components/block-products-carousel-new/block-products-carousel-new.module';
import { BlockProductCarouselModule } from './_components/block-products-carousel/block-products-carousel.module';
import { BlockRealEstateCarouselModule } from './_components/block-realestate-carousel/block-realestate-carousel.module';
import { LiveChatModule } from './_components/live-chat/live-chat.module';
import { FooterModule } from './pages/footer/footer.module';
import { HeaderNewModule } from './pages/header-new/header-new.module';
import { HeaderModule } from './pages/header/header.module';
import { MobileNewModule } from './pages/mobile-new/mobile-new.module';
import { MobileModule } from './pages/mobile/mobile.module';
import { SharedModule } from './shared/shared.module';
import { WidgetsModule } from './widgets/widgets.module';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}
@NgModule({
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        MatNativeDateModule,
        CarouselModule,
        AppRoutingModule,
        FooterModule,
        HeaderModule,
        HeaderNewModule,
        MobileModule,
        MobileNewModule,
        SharedModule,
        WidgetsModule,
        BlockProductCarouselModule,
        BlockRealEstateCarouselModule,
        BlockProductCarouselNewModule,
        NgxJsonLdModule,
        HttpClientModule,
        LiveChatModule,
        MatIconModule
    ],
    providers: [
        Title,
        { provide: APP_ID, useValue: 'serverApp' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CookieInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NotFoundInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CountryInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MaintenanceInterceptor,
            multi: true
        }
    ]
})
export class AppModule {}
